module.exports = __webpack_public_path__ + "media/never_gonna_give_you_up.7391583e.mp3";